import Siema from 'siema';
import COMMON_SETTINGS from '../settings/settings.common-settings';

const   this_carousels = [...document.querySelectorAll('.js-carousel')],
        classes = {
            carousel_active:    'is-carousel',
            is_active:          'active',
            is_disabled:        'is-disabled',
        };

function init () {
    this_carousels.forEach( function ( this_carousel ) {
        const this_carousel_list = this_carousel.querySelector('.js-carousel-list');

        if ( this_carousel_list ) {
            const   carousel_item_count = this_carousel_list.children.length,
                    carousel_items = [...this_carousel_list.children],
                    carousel_prev = this_carousel.querySelector('.js-carousel-prev'),
                    carousel_next = this_carousel.querySelector('.js-carousel-next'),
                    carousel_counters = this_carousel.querySelector('.js-carousel-counters'),

                    items_per_page = this_carousel.dataset.itemsPerPage,
                    is_infinite = this_carousel.classList.contains( 'infinite' ),
                    is_dynamic_height = this_carousel.classList.contains( 'dynamic-height' ),
                    is_equal_height = this_carousel.classList.contains( 'equal-height' ),
                    is_auto_transition = this_carousel.classList.contains( 'auto-transition' );

            let     previous_window_width = window.innerWidth,
                    carousel,
                    counter_elements = [];

            if ( carousel_item_count > get_items_per_page() ) init();

            function init () {
                if ( is_dynamic_height && is_equal_height ) console.error( `Carousel: '${ this_carousel }' has both equal and dynamic height. Will ignore equal height in place of dynamic heights.` );
                if ( carousel_counters ) {
                    carousel_counters.innerHTML = '';
                    counter_elements = [];
                }

                this_carousel.classList.remove( classes.carousel_active );

                carousel = new Siema( {
                    selector: this_carousel_list,
                    easing: 'ease-out',
                    startIndex: 0,
                    perPage: get_items_per_page(),
                    draggable: false,
                    loop: is_infinite,
                    onInit: () => {
                        if ( carousel_prev && !is_infinite ) disableButton( carousel_prev );
                        if ( is_equal_height ) equal_height_items();
                        if ( is_dynamic_height ) set_current_dynamic_height( 0 );
                        if ( carousel_counters ) create_counters();
                        if ( is_auto_transition ) start_auto_slide();
                        if ( carousel_prev ) carousel_prev.addEventListener( 'click', ( event ) => act_on_control_click( -1, carousel_prev, carousel_next ) );
                        if ( carousel_next ) carousel_next.addEventListener( 'click', ( event ) => act_on_control_click( 1, carousel_next, carousel_prev , carousel_item_count - 1 ) );

                        carousel_items[ 0 ].classList.add( classes.is_active );
                        this_carousel.classList.add( classes.carousel_active );
                    },
                    onChange: () => {
                        set_active_item_in_list( carousel_items );
                        if ( carousel_counters ) set_active_item_in_list( [...counter_elements] );
                        if ( is_dynamic_height ) set_current_dynamic_height( carousel.currentSlide );
                    }
                } );
            }

            function start_auto_slide () {
                setInterval( () => {
                    act_on_control_click( 1, carousel_next, carousel_prev , carousel_item_count - 1 );
                }, parseInt( this_carousel.dataset.transitionDuration ) )
            }

            function set_active_item_in_list ( list ) {
                list.forEach( ( item ) => item.classList.remove( classes.is_active ) );
                list[ carousel.currentSlide ].classList.add( classes.is_active );
            }

            function create_counters () {
                for ( let i = 0; i < ( carousel_item_count - ( get_items_per_page() - 1 ) ); i++ ) {
                    let carouselCounter = document.createElement('li');
                    counter_elements.push( carouselCounter );

                    if ( i == 0 ) carouselCounter.classList.add('is-active');

                    carouselCounter.addEventListener( 'click', () => carousel.goTo( i ) );
                    carousel_counters.appendChild( carouselCounter );
                 }
            }
            
            function act_on_control_click ( polarity, btn_to_disable, btn_to_enable, comparitor = 0 ) {
                const new_slide = carousel.currentSlide + polarity;

                carousel.goTo( new_slide );

                if ( new_slide === comparitor && !is_infinite ) disableButton( btn_to_disable );
                enableButton( btn_to_enable );
            }

            function disableButton ( button ) {
                if ( button ) button.classList.add( classes.is_disabled );
            }

            function enableButton ( button ) {
                if ( button ) button.classList.remove( classes.is_disabled );
            }

            function get_items_per_page () {
                if ( items_per_page ) {
                    items_per_page_split = items_per_page.split(',');

                    if ( items_per_page_split.length === 3 ) {
                        if ( window.matchMedia( COMMON_SETTINGS.matchMediaBreakpoints.wide ).matches ) {
                            return parseInt( items_per_page_split[2] );
                        } else if ( window.matchMedia( COMMON_SETTINGS.matchMediaBreakpoints.tablet ).matches ) {
                            return parseInt( items_per_page_split[1] );
                        } else {
                            return parseInt( items_per_page_split[0] );
                        }
                    }
                }

                return 1;
            }

            function set_current_dynamic_height ( index ) {
                this_carousel_list.style.height = carousel_items[ index ].offsetHeight + 'px';
            }

            function equal_height_items () {
                set_block_heights_to( carousel_items, 'auto' );
                set_block_heights_to( carousel_items, get_max_height_of_elements( carousel_items ) );
            }

            function get_max_height_of_elements ( elements ) {
                return Math.max( ...elements.map( element => element.offsetHeight ) );
            }

            function set_block_heights_to ( elements, block_height ) {
                elements.forEach( element => element.style.height = ( block_height + ( isNaN( block_height ) ? '' : 'px' ) ) );
            }

            window.addEventListener( 'resize', () => {
                if ( previous_window_width !== window.innerWidth ) {
                    carousel.destroy( true );
                    init();
                }
            } );
        }
    } );
}

init();